exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\nfooter {\n    background-color: #333;\n    width: 100%;\n    bottom: 0;\n    position: fixed;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/shareview/shareview.component.css
// module id = ../../../../../src/app/shareview/shareview.component.css
// module chunks = main